import { Amplify } from 'aws-amplify';

// Extend window interface for injected config
declare global {
  interface Window {
    __BNB_CONFIG__?: Record<string, string>;
  }
}

// Get environment variables with validation and fallback to injected config
const getEnvVar = (key: string, fallback?: string): string => {
  // First try Vite environment variables
  let value = import.meta.env[key];
  
  // If not found, try injected configuration
  if ((!value || value === 'undefined') && typeof window !== 'undefined' && window.__BNB_CONFIG__) {
    value = window.__BNB_CONFIG__[key];
  }
  
  // If still not found, use fallback
  if (!value || value === 'undefined') {
    if (fallback) return fallback;
    console.warn(`Configuration ${key} is not set`);
    return '';
  }
  return value;
};

const region = getEnvVar('VITE_AWS_REGION', 'us-east-1');
const userPoolId = getEnvVar('VITE_COGNITO_USER_POOL_ID', 'us-east-1_FfCAP8xJQ');
const userPoolWebClientId = getEnvVar('VITE_COGNITO_USER_POOL_CLIENT_ID', '1g9t43begi8c2t3t9tkn32v7d8');
const cognitoDomain = getEnvVar('VITE_COGNITO_DOMAIN', 'bnb-platform.auth.us-east-1.amazoncognito.com');
const apiUrl = getEnvVar('VITE_API_URL', 'https://apis.bnbcart.com');

// Log configuration for debugging
console.log('Amplify Configuration:', {
  region,
  userPoolId: userPoolId ? `${userPoolId.substring(0, 10)}...` : 'NOT SET',
  userPoolWebClientId: userPoolWebClientId ? `${userPoolWebClientId.substring(0, 10)}...` : 'NOT SET',
  cognitoDomain,
  apiUrl
});

const amplifyConfig = {
  Auth: {
    region,
    userPoolId,
    userPoolWebClientId,
    // OAuth configuration for Google sign-in
    oauth: {
      domain: cognitoDomain,
      scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: getEnvVar('VITE_REDIRECT_SIGN_IN', window.location.origin + '/dashboard'),
      redirectSignOut: getEnvVar('VITE_REDIRECT_SIGN_OUT', window.location.origin + '/'),
      responseType: 'code'
    }
  },
  API: {
    endpoints: [
      {
        name: 'bnbapi',
        endpoint: apiUrl,
        region
      }
    ]
  }
};

// Only configure Amplify if we have the required auth properties
if (userPoolId && userPoolWebClientId) {
  Amplify.configure(amplifyConfig);
  console.log('Amplify configured successfully');
} else {
  console.error('Cannot configure Amplify: Missing required Cognito configuration');
  console.error('Required: VITE_COGNITO_USER_POOL_ID, VITE_COGNITO_USER_POOL_CLIENT_ID');
}

export default amplifyConfig;